import type { useFormDialog } from './hooks/useFormDialog';
import { PhiNganHangTab } from './PhiNganHangTab';
import { ThanhToanTab } from './ThanhToanTab';
import UyNhiemChiTab from './UyNhiemChiTab';
import { DetailTab } from './DetailTab';
import { BottomBar } from './BottomBar';
import { TyGiaTab } from './TyGiaTab';
import { OtherTab } from './OtherTab';
import { ThueTab } from './ThueTab';

type DialogModel = ReturnType<typeof useFormDialog>;

export const FormTabs = (dialog: DialogModel) =>
  dialog.activeTab === 'info'
    ? [
        {
          id: 'details',
          label: 'Chi tiết',
          component: <DetailTab formMode={dialog.formMode} {...dialog.detail.tableProps} />
        },
        {
          id: 'thue',
          label: 'Thuế',
          component: <ThueTab formMode={dialog.formMode} {...dialog.tax.tableProps} />
        },
        {
          id: 'thong_tin_thanh_toan',
          label: 'Thông tin thanh toán',
          component: (
            <ThanhToanTab
              formMode={dialog.formMode}
              hanTT={dialog.formState.state.hanTT}
              setHanTT={dialog.formState.actions.setHanTT}
            />
          )
        },
        {
          id: 'ty_gia',
          label: 'Tỷ giá',
          component: <TyGiaTab formMode={dialog.formMode} />
        },
        {
          id: 'phi_nganHang',
          label: 'Phí ngân hàng',
          component: <PhiNganHangTab formMode={dialog.formMode} {...dialog.bankFee.tableProps} />
        },
        {
          id: 'uy_nhiem_chi',
          label: 'Ủy nhiệm chi',
          component: (
            <UyNhiemChiTab
              formMode={dialog.formMode}
              state={dialog.formState.state}
              actions={dialog.formState.actions}
            />
          )
        },
        {
          id: 'khac',
          label: 'Khác',
          component: <OtherTab formMode={dialog.formMode} rows={dialog.detail.rows} />
        }
      ]
    : undefined;

export const FormBottomBar = (dialog: DialogModel) =>
  dialog.activeTab === 'info' ? (
    <BottomBar
      tong_tien={dialog.totals.tong_tien}
      tong_thue={dialog.totals.tong_thue}
      tong_phi={dialog.totals.tong_phi}
      tong_thanh_toan={dialog.totals.tong_thanh_toan}
    />
  ) : null;
